<template>
  <div class="order-now">
    <RestaurantModal
      :restaurantDetails="restaurantToShow"
      v-if="showMenu"
      @close-restaurant-modal="triggerRestaurantMenu"
    />
    <div class="card-view-wrap">
      <div class="container">
        <h3>Order Now!</h3>
        <div class="cards" id="infinite-list">
          <CardView
            @show-restaurant="triggerRestaurantMenu"
            v-for="(restaurant, index) in restaurantsData"
            :key="index"
            :restaurant="restaurant"
          />
        </div>
        <div class="load-more-button">
          <button
            v-show="startDisplay"
            :class="loadRestaurants ? 'button-1' : 'button-2'"
            @click.prevent="getNextRestaurants"
          >
            {{ this.buttonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardView from "../components/CardView";
import RestaurantModal from "../components/RestaurantModal";
//import firebase from "firebase/app";
import db from "../firebase/firebaseInit";
import "mosha-vue-toastify/dist/style.css";
export default {
  name: "OrderNow",
  components: {
    CardView,
    RestaurantModal,
  },
  data() {
    return {
      restaurantsData: [],
      showMenu: false,
      restaurantToShow: null,
      lastRestaurantRetrieved: null,
      loadRestaurants: true,
      buttonText: "Load More",
      startDisplay: false,
      //orderNowContainer: null,
    };
  },
  created() {
    // ONLY USE WINDOW IN VUE FOR EVENTlistener, SO FAR THATS WHAT IS WORKING :(, DEBUGGIN..
    //window.addEventListener("DOMContentLoaded", this.getNextRestaurants);
    //this.orderNowContainer = document.querySelector(".order-now");
    this.getNextRestaurants();
    //window.addEventListener("scroll", this.handleScrollLoading);
  },
  /*
  mounted() {
    const listElm = document.querySelector("#infinite-list");
    window.addEventListener("scroll", () => {
      if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
        this.getNextRestaurants();
      }
    });
  },
  */
  methods: {
    /**
     * Infinite Scroll Trials :(
     */
    /*
    handleScrollLoading() {
      let triggerHeight = window.scrollTop + window.offsetHeight;
      if (triggerHeight >= window.scrollHeight) {
        this.getNextRestaurants();
      }
    },
    */
    async getNextRestaurants() {
      //Means can get more restaurants, else reacheed end.
      if (this.loadRestaurants) {
        const ref = db
          .collection("restaurants")
          .orderBy("name")
          .startAfter(this.lastRestaurantRetrieved || 0)
          .limit(8);
        const data = await ref.get();
        data.docs.forEach((doc) => {
          const restaurantData = doc.data();
          const restaurant = {
            // Getting ID
            id: doc.id,
            name: restaurantData.name,
            photo: restaurantData.photo,
            location: restaurantData.location,
            tags: restaurantData.tags,
            itemNames: restaurantData.itemNames,
            itemValues: restaurantData.itemValues,
          };
          this.restaurantsData.push(restaurant);
          /*
        // Doesnt seem to be working in Vue , to see if loaded all data.
        //FIXED, DOESNT WORK INSIDE the forEach lol
        if (data.empty) {
          console.log("Done");
        }
        */
        });
        this.lastRestaurantRetrieved = data.docs[data.docs.length - 1];
        //console.log("restaurant : ", this.lastRestaurantRetrieved);
        this.startDisplay = true;
        if (data.empty) {
          //console.log("Done");
          this.$toast("No More Restaurants To Show!", {
            // toast ID
            id: "endPage",
            // notification type
            // success, error, default, info and warning
            type: "default",
            // top-right, top-center, top-left, bottom-right, bottom-center, bottom-left.
            position: "top-center",
            // allows to dismiss by drag &amp; swipe events
            draggable: true,
            draggablePercent: 0.6,
            // auto pause when out of focus
            pauseOnFocusLoss: true,
            // auto pause on hover
            pauseOnHover: true,
            // close on click
            closeOnClick: true,
            // auto dismiss after this timeout
            timeout: 5000,
            // custom classes
            toastClassName: [],
            // body classes
            bodyClassName: [],
            // show/hide the progress bar
            hideProgressBar: false,
            // show/hide the close button
            hideCloseButton: false,
            // custom icons here
            icon: true,
            // callback
            onClick: function() {},
          });
          this.loadRestaurants = false;
          this.buttonText =
            "You Have Reached the End of the List! But Don't Worry, More Restaurants Would Soon Come to the Rescue!";
          // Dont know why not removing/deetaching event ahhh
          //window.removeEventListener("click", this.getNextRestaurants);
        }
      }
    },
    /*
    async getNRestaurants() {
      const dataBase = db.collection("restaurants");
      const data = await dataBase.get();
      data.docs.forEach((doc) => {
        const restaurant = {
          name: doc.data().name,
          photo: doc.data().photo,
          location: doc.data().location,
        };
        this.restaurantsData.push(restaurant);
      });
    },
    */
    triggerRestaurantMenu(res) {
      this.restaurantToShow = res;
      this.showMenu = !this.showMenu;
    },
  },
};
</script>

<style lang="scss" scoped>
.load-more-button {
  .button-1 {
    margin: 0 auto;
    margin-top: 30px;
    display: block;
    cursor: pointer;
  }
  .button-2 {
    margin: 0 auto;
    margin-top: 30px;
    display: block;
    width: 100%;
    background-color: #000;
    border: none;
    font-weight: 500;
    @media (max-width: 900px) {
      height: 100px;
    }
  }
}
.order-now {
  margin-top: 0px;
  p {
    margin-top: 20px;
    text-align: center;
    font-size: 40px;
  }
}
.card-view-wrap {
  //padding: 0;
  .container {
    h3 {
      font-weight: 300;
      font-size: 40px;
      //font-size: 28px;
      margin-bottom: 32px;
      text-align: center;
    }
  }
}
</style>
